import React from 'react'
import PropTypes from 'prop-types'
import { useAppSelector } from 'utils/custom-hooks/useTypedReduxStore'
import { Grid, Typography, Stack, Box } from '@mui/material'
import { PRINT_DIALOG_TYPES } from 'utils/constants'
import {
  convertShippingInfoToCityStateZip,
  formatAddress,
  formatPhoneNumber,
} from 'utils/data-manipulation/valueFormatter'
import { PrintDialogType } from 'components/containers/customers/locations/types'

interface LogoAddressProps {
  dialogType: PrintDialogType
  logoSrc?: string
  onAfterLoadLogo?: () => void
  showLogoAddress?: boolean
}

const LogoAddress: React.FC<LogoAddressProps> = ({
  dialogType,
  logoSrc = '',
  onAfterLoadLogo = () => {},
  showLogoAddress = false,
}) => {
  const { logoHeight, fontSize, lineHeight } = dialogType
  const { addressName, address, address2, city, state, zip, logo, phoneNumber } = useAppSelector(
    state => state.settings.details,
  )
  const organizationDetails = useAppSelector(state => state.auth.organizationDetails)
  const { settings } = useAppSelector(state => state.settings)
  const { includeAddressInDocumentHeader } = settings?.documentSettings?.general || {}
  const isLogoEnabled = !!logo
  const taxId = organizationDetails?.taxId

  const Text = ({ content }) => (
    <Typography variant="caption" sx={{ fontSize, lineHeight }}>
      {content}
    </Typography>
  )

  Text.propTypes = {
    content: PropTypes.node.isRequired,
  }

  return showLogoAddress ? (
    <Grid item display="flex" flexWrap="wrap" alignItems="center" justifyContent="space-between" width="100%">
      {isLogoEnabled && logoSrc && (
        <Box display="flex" alignItems="center" height={logoHeight}>
          <img onLoad={onAfterLoadLogo} alt="Logo" src={logoSrc} style={{ maxHeight: '100%' }} />
        </Box>
      )}
      {includeAddressInDocumentHeader && (
        <Stack alignItems="flex-start">
          <Text content={addressName || ''} />
          {dialogType !== PRINT_DIALOG_TYPES.PULL_APART_TAG && (
            <>
              <Text content={formatAddress({ address, address2 })} />
              <Text content={convertShippingInfoToCityStateZip({ city, state, zip })} />
              <Text content={formatPhoneNumber?.(phoneNumber) || ''} />
              {taxId && <Text content={`G.S.T. No. ${taxId}`} />}
            </>
          )}
        </Stack>
      )}
    </Grid>
  ) : null
}

export default LogoAddress
